import { CreateInstitutionWithAddresses } from "../types/institution.types";
import { ResponseData } from "./types";
import { httpClient } from "./common";
import { withApiErrorHandling } from "../APIs/withApiErrorHandling";

export class InstitutionsAPI {
  private static readonly API_URL = "/institutions";

  static async getInstitutions(): Promise<ResponseData<any>> {
    return withApiErrorHandling(
      () => httpClient.get(this.API_URL, true),
      "Error al obtener las instituciones"
    );
  }

  static async postInstitution(
    data: CreateInstitutionWithAddresses
  ): Promise<ResponseData<any>> {
    return withApiErrorHandling(
      () => httpClient.post(this.API_URL, data, true),
      "Error al crear la institución"
    );
  }

  static async getInstitution(id: number) {
    return withApiErrorHandling(
      () => httpClient.get(`${this.API_URL}/${id}`, true),
      "Error al obtener la institución"
    );
  }

  static async updateInstitution(id: number, data: any) {
    return withApiErrorHandling(
      () => httpClient.patch(`${this.API_URL}/${id}`, data, true),
      "Error al actualizar la institución"
    );
  }

  static async deleteInstitution(id: number) {
    return withApiErrorHandling(
      () => httpClient.delete(`${this.API_URL}/${id}`, true),
      "Error al eliminar la institución"
    );
  }
}
